<template>
  <section class="mb-0" style="padding-top: 7rem;">
    <div class="bg-holder">
      <img style="width:100%;" src="../../assets/img/hero/hero-bg.svg" alt="hero-header" />
    </div>
    <!--/.bg-holder-->

    <div class="container" id="topSliderCon">

      <div class="row align-items-center">
        <div class="col-md-5 col-lg-6 order-0 order-md-1 text-end"><img class="pt-7 pt-md-0 hero-img" style="width:75%;"
            src="../../assets/img/hero/112.png" alt="hero-header" /></div>
        <div class="col-md-7 col-lg-6 text-md-start text-center py-6">
          <h4 class="fw-bold text-danger mb-3">Best Destinations around the Srilanka <img
              src="https://cdn-icons-png.flaticon.com/512/4062/4062514.png" style="height: 50px;"></h4>
          <h1 class="hero-title">Travel, enjoy and live a new and full life</h1>
          <p class="mb-4 fw-medium">Built Wicket longer admire do barton vanity itself do in it.<br
              class="d-none d-xl-block" />Preferred to sportsmen it engrossed listening. Park gate<br
              class="d-none d-xl-block" />sell they west hard for the.</p>

          <div class="text-center text-md-start">

            <div class="w-100 d-block d-md-none"></div><a href="#!" role="button" data-bs-toggle="modal" data-bs-target="#popupVideo"><span class="col-6 btn btn-info btn-lg me-md-4 mb-3 mb-md-0 border-0 primary-btn-shadow"> Fill Up More! </span></a>
                <div class="modal fade" id="popupVideo" tabindex="-1" aria-labelledby="popupVideo" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered modal-xl">
                    <div class="modal-content" style="border-radius: 10px;border: 0px solid rgba(0, 0, 0, 0.2);">
                      <div class="modal-header">

                        <img src="https://www.srilankatourismalliance.com/wp-content/uploads/2020/05/banner-desktop-1.jpg"
                          style="width: 100%;">

                      </div>
                      <div class="modal-body">

                        <div class="box-body">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="card mt-3">
                                <div class="card-header">
                                  <h5 class="card-title">Attraction information</h5>
                                </div>
                                <div class="card-body">
                                  <div class="row">
                                    <div class="col-12">
                                      <div class="row">
                                        <div class="col-md-4">
                                          <label for="name" class="control-label mt-3">Name :</label>
                                          <input type="text" class="col-12 inputText form-control" placeholder="Type Here..."
                                            id="name" name="name">
                                        </div>

                                        <div class="col-md-4">
                                          <label for="mainCategory" class="control-label mt-3">Category :</label>
                                          <select class="inputText form-control" id="mainCategory" name="mainCategory">
                                            <option value="" selected>- Select -</option>
                                          </select>
                                        </div>


                                        <div class="col-md-4">
                                          <div id="subCatDiv">
                                            <label for="subCategory" class="control-label mt-3">Sub Category :</label>
                                            <select class="inputText form-control" id="subCategory" name="subCategory">
                                              <option value="">- Select -</option>
                                            </select>
                                          </div>
                                        </div>

                                        <div class="col-12 form-control-group">
                                          <label for="name" class="control-label mt-3">Add Images :</label>
                                          <input class="inputText form-control" type="file" id="imageUpload1" name="images[]"
                                            accept="image/*" multiple>
                                        </div>

                                        <div class="col-12 form-control-group">
                                          <label for="name" class="control-label mt-3">Images Preview :</label>
                                          <div id="imagePreview" class="preview"></div>
                                        </div>

                                        <div class="col-12 form-control-group">
                                          <label for="name" class="control-label mt-3">Describtion Filed :</label>
                                          <QuillEditor theme="snow" toolbar="full" class="form-control"
                                            style="height: 300px;border-radius: 0px;" id="comments" name="comments"></QuillEditor>
                                        </div>

                                      </div>
                                    </div>

                                  </div>

                                </div>
                              </div>
                              <div class="card mt-3">
                                <div class="card-header">
                                  <h5 class="card-title">Location information</h5>
                                </div>
                                <div class="card-body">
                                  <div class="row">
                                    <div class="col-4">
                                      <div class="row">
                                        <div class="col-12">
                                          <button class="btn btn-info btn-flat" id="manualAddress" style="float: inline-end;">
                                            Enter Manual</button>
                                          <button class="btn btn-primary btn-flat" id="autoAddress" style="float: inline-end;">
                                            Enter Auto</button>
                                        </div>
                                        <div id="autoAddressDiv">

                                          <div class="col-12 autoAddress">
                                            <label for="placeAutoAddress" class="mt-3 control-label">Address</label>
                                            <input class="inputText form-control" id="placeAutoAddress" name="placeAutoAddress"
                                              placeholder="Enter address or click on map" v-model="placeAutoAddress">

                                          </div>

                                          <div class="col-12 autoAddress" id="lat">
                                            <label for="placeAutoLattitude" class="control-label mt-3">Lattitude</label>
                                            <input type="text" class="inputText form-control" id="placeAutoLattitude"
                                              name="placeAutoLattitude" v-model="latitude" readonly>
                                          </div>

                                          <div class="col-12 autoAddress" id="long">
                                            <label for="placeAutoLongtitude" class="control-label mt-3">Longtitude</label>
                                            <input type="text" class="inputText form-control" id="placeAutoLongtitude"
                                              name="placeAutoLongtitude" v-model="longitude" readonly>
                                          </div>

                                          <div class="col-12 autoAddress">
                                            <label for="placeAutoCountry" class="control-label mt-3">Country</label>
                                            <input type="text" class="inputText form-control" id="placeAutoCountry"
                                              name="placeAutoCountry" v-model="country" readonly>
                                          </div>

                                          <div class="col-12 autoAddress">
                                            <label for="placeAutoState" class="control-label mt-3">Province/District</label>
                                            <input type="text" class="inputText form-control" id="placeAutoState"
                                              name="placeAutoState" v-model="state" readonly>
                                          </div>
                                          <div class="col-12 autoAddress">
                                            <label for="placeAutoCity" class="control-label mt-3">City</label>
                                            <input type="text" class="inputText form-control" id="placeAutoCity" name="placeAutoCity"
                                              v-model="city" readonly>
                                          </div>
                                        </div>

                                      </div>
                                      <input type="hidden" value="0" id="addressType">
                                      <div class="row" id="manualAddressDiv">
                                        <div class="col-12 manualAddress">
                                          <label for="placeManualAddress" class="mt-3 control-label">Address</label>
                                          <input class="inputText form-control manualAddress" id="placeManualAddress"
                                            name="placeManualAddress" value="" placeholder="Type Address Here...">
                                        </div>

                                        <div class="col-12 manualAddress">
                                          <label for="placeManualCountry" class="control-label mt-3">Country</label>
                                          <select class="inputText form-control" id="placeManualCountry" name="placeManualCountry">
                                            <option value="">- Select -</option>
                                          </select>
                                        </div>

                                        <div class="col-12 manualAddress">
                                          <label for="placeManualDistrictProvince"
                                            class="control-label mt-3">District/Province</label>
                                          <select class="inputText form-control" id="placeManualDistrictProvince"
                                            name="placeManualDistrictProvince">
                                            <option value="">- Select -</option>
                                          </select>
                                        </div>

                                        <div class="col-12 manualAddress">
                                          <label for="placeManualCity" class="control-label mt-3">City</label>
                                          <select class="inputText form-control" id="placeManualCity" name="placeManualCity">
                                            <option value="">- Select -</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- <MapComponent :updateLocation="updateLocationFields" id="mapDiv" /> -->
                                    <div class="col-8">
                                      <div class="col-12">
                                        <div id="map">

                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="card mt-3">
                                <input type="hidden" value="0" id="openType" name="openType">
                                <div class="card-header">
                                  <h5 class="card-title">Functional days information</h5>
                                </div>
                                <div class="card-body" id="question">
                                  <div class="col-12">
                                    <label for="placeLongtitude" class="control-label mt-3">Is this 24Hrs Open?</label>
                                    <br>
                                    <!-- <a class="btn btn-info btn-flat" id="yes"> Yes</a>
                                    <a class="btn btn-danger btn-flat" id="no"> No</a>
                                    -->
                                    <div class="form-check form-switch">
                                      <input class="form-check-input" style="width:60px; height: 20px;" type="checkbox" id="yes"
                                        checked>
                                    </div>

                                  </div>
                                </div>
                                <div class="card-body" id="24hr">
                                  <div class="col-12">
                                    <label for="placeLongtitude" class="btn btn-info btn-flat mt-3">This is 24Hrs open
                                      place</label>
                                    <a class="btn btn-danger btn-flat mt-2" id="no2"> No</a>
                                    <br>
                                  </div>
                                </div>
                                <div class="col-12 card-body" id="timeTable" v-show="areFieldsHiddenNo">
                                  <table class="col-12">
                                    <thead>
                                      <tr>
                                        <th style="padding-right: 10px;padding-top: 10px;">Day</th>
                                        <th style="padding-right: 10px;padding-top: 10px;">Open Time</th>
                                        <th style="padding-right: 10px;padding-top: 10px;">Close Time</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td style="padding-right: 10px;padding-top: 10px;">Monday</td>
                                        <td style="padding-right: 10px;padding-top: 10px;"><input type="time"
                                            class="inputText form-control" id="mondayOpen" name="mondayOpen" placeholder="Open time"
                                            onchange="validateTime('mondayOpen', 'mondayClose')"></td>
                                        <td style="padding-right: 10px;"><input type="time" class="inputText form-control"
                                            id="mondayClose" name="mondayClose" placeholder="Close time"
                                            onchange="validateTime('mondayOpen', 'mondayClose')"></td>
                                      </tr>
                                      <tr>
                                        <td style="padding-right: 10px;padding-top: 10px;">Tuesday</td>
                                        <td style="padding-right: 10px;padding-top: 10px;"><input type="time"
                                            class="inputText form-control" id="tuesdayOpen" name="tuesdayOpen" placeholder="Open time"
                                            onchange="validateTime('tuesdayOpen', 'tuesdayClose')"></td>
                                        <td style="padding-right: 10px;padding-top: 10px;"><input type="time"
                                            class="inputText form-control" id="tuesdayClose" name="tuesdayClose"
                                            placeholder="Close time" onchange="validateTime('tuesdayOpen', 'tuesdayClose')"></td>
                                      </tr>
                                      <tr>
                                        <td style="padding-right: 10px;padding-top: 10px;">Wednesday</td>
                                        <td style="padding-right: 10px;padding-top: 10px;"><input type="time"
                                            class="inputText form-control" id="wednesdayOpen" name="wednesdayOpen"
                                            placeholder="Open time" onchange="validateTime('wednesdayOpen', 'wednesdayClose')"></td>
                                        <td style="padding-right: 10px;padding-top: 10px;"><input type="time"
                                            class="inputText form-control" id="wednesdayClose" name="wednesdayClose"
                                            placeholder="Close time" onchange="validateTime('wednesdayOpen', 'wednesdayClose')"></td>
                                      </tr>
                                      <tr>
                                        <td style="padding-right: 10px;padding-top: 10px;">Thursday</td>
                                        <td style="padding-right: 10px;padding-top: 10px;"><input type="time"
                                            class="inputText form-control" id="ThursdayOpen" name="ThursdayOpen"
                                            placeholder="Open time" onchange="validateTime('ThursdayOpen', 'ThursdayClose')"></td>
                                        <td style="padding-right: 10px;padding-top: 10px;"><input type="time"
                                            class="inputText form-control" id="ThursdayClose" name="ThursdayClose"
                                            placeholder="Close time" onchange="validateTime('ThursdayOpen', 'ThursdayClose')"></td>
                                      </tr>
                                      <tr>
                                        <td style="padding-right: 10px;padding-top: 10px;">Friday</td>
                                        <td style="padding-right: 10px;padding-top: 10px;"><input type="time"
                                            class="inputText form-control" id="FridayOpen" name="FridayOpen" placeholder="Open time"
                                            onchange="validateTime('FridayOpen', 'FridayClose')"></td>
                                        <td style="padding-right: 10px;padding-top: 10px;"><input type="time"
                                            class="inputText form-control" id="FridayClose" name="FridayClose"
                                            placeholder="Close time" onchange="validateTime('FridayOpen', 'FridayClose')"></td>
                                      </tr>
                                      <tr>
                                        <td style="padding-right: 10px;padding-top: 10px;">Saturday</td>
                                        <td style="padding-right: 10px;padding-top: 10px;"><input type="time"
                                            class="inputText form-control" id="SaturdayOpen" name="SaturdayOpen"
                                            placeholder="Open time" onchange="validateTime('SaturdayOpen', 'SaturdayClose')"></td>
                                        <td style="padding-right: 10px;padding-top: 10px;"><input type="time"
                                            class="inputText form-control" id="SaturdayClose" name="SaturdayClose"
                                            placeholder="Close time" onchange="validateTime('SaturdayOpen', 'SaturdayClose')"></td>
                                      </tr>
                                      <tr>
                                        <td style="padding-right: 10px;padding-top: 10px;">Sunday</td>
                                        <td style="padding-right: 10px;padding-top: 10px;"><input type="time"
                                            class="inputText form-control" id="SundayOpen" name="SundayOpen" placeholder="Open time"
                                            onchange="validateTime('SundayOpen', 'SundayClose')"></td>
                                        <td style="padding-right: 10px;padding-top: 10px;"><input type="time"
                                            class="inputText form-control" id="SundayClose" name="SundayClose"
                                            placeholder="Close time" onchange="validateTime('SundayOpen', 'SundayClose')"></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-info" id="saveBtn">Save</button>
                        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                      </div>
                    </div>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Modal -->
  <section class="" id="fillMore">
    <div class="container">
      
    </div>
  </section>



</template>

<script>
import { QuillEditor } from '@vueup/vue-quill';
// import axios from 'axios';

import { ref } from 'vue';
//import MapComponent from './MapComponents.vue';
import $ from 'jquery';
import Swal from 'sweetalert2';

export default {
  name: 'TopSliderPage',
  components: {
    QuillEditor,
    // MapComponent
  },
  setup() {
    const latitude = ref('');
    const longitude = ref('');
    const country = ref('');
    const state = ref('');
    const city = ref('');
    const placeAutoAddress = ref('');

    const addressInput = ref(null);

    const updateLocationFields = ({ latitude: lat, longitude: lng, country: ctry, state: st, city: cty, placeAutoAddress: plaAdd }) => {
      latitude.value = lat;
      longitude.value = lng;
      country.value = ctry;
      state.value = st;
      city.value = cty;
      placeAutoAddress.value = plaAdd;
    };

    return {
      // Initial state for input fields visibility
      latitude,
      longitude,
      country,
      state,
      city,
      placeAutoAddress,
      updateLocationFields,

      addressInput,

    };
  },
  data() {
    return {
      areFieldsHiddenYes: false, // Initial state for input fields visibility
      areFieldsHiddenNo: false, // Initial state for input fields visibility
      buttonDiv: true,

    };
  },
  mounted() {
    this.fetchOptions();   // Fetch data when component is mounted
    this.fetchCountry();
    this.initializeEventListeners();
    this.autoLocation();
    this.initializeAutocomplete();
    this.getCountryCodesForAddressFiltter();

    $('#manualAddress').show();
    $('#autoAddress').hide();
  },
  methods: {


    async fetchOptions() {
      console.log("working...");
      try {
        $.ajax({
          url: process.env.VUE_APP_API_URL +'/fetchCategories',
          method: 'GET',
          success: (data) => {
            // Populate dropdown options
            const $dropdown = $('#mainCategory');
            $dropdown.empty(); // Clear existing options
            $dropdown.append($('<option>', {
              value: '',
              text: 'Select Category'
            }));
            // Append new options
            data.forEach(option => {
              $dropdown.append($('<option>', {
                value: option.id,
                text: option.name
              }));


            });

          },
          error: (jqXHR, textStatus, errorThrown) => {
            console.error('Error fetching options:', textStatus, errorThrown);
          }
        });

      } catch (error) {
        console.error('Error fetching options:', error);
      }
    },

    fetchSubcategories(categoryId) {
      // console.log("working...222");
      $.ajax({
        url: process.env.VUE_APP_API_URL +`/fetchSubcategories?categoryId=${categoryId}`,
        method: 'GET',
        success: (data) => {
          // Populate dropdown options
          const $dropdown = $('#subCategory');
          $dropdown.empty(); // Clear existing options
          $dropdown.append($('<option>', {
            value: '',
            text: 'Select Sub Category'
          }));
          // Append new options
          data.forEach(option => {
            $dropdown.append($('<option>', {
              value: option.id,
              text: option.name
            }));
          });
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.error('Error fetching options:', textStatus, errorThrown);
        }
      });
    },
    autoLocation() {
      $('.autoAddress').show();
      $('.manualAddress').hide();
      $('#addressType').val(0);
      $('#autoAddress').hide();
      $('#manualAddress').show();

      $('#map').css({
        'pointer-events': '',
        'opacity': ''
      }).removeClass('disabled');
    },  
    manualLocation() {
      $('.autoAddress').hide();
      $('.manualAddress').show();
      $('#addressType').val(1);
      $('#autoAddress').show();
      $('#manualAddress').hide();

      $('#map').css({
        'pointer-events': 'none',
        'opacity': '0.5'
      }).addClass('disabled');

    },

    async fetchCountry() {
      console.log("working...1");
      try {
        $.ajax({
          url: process.env.VUE_APP_API_URL +"/fetchCountry",
          method: "GET",
          success: (data) => {
            console.log(data);
            // Populate dropdown options
            const $dropdown = $("#placeManualCountry");
            $dropdown.empty(); // Clear existing options
            $dropdown.append(
              $("<option>", {
                value: '',
                text: "Select Country",
              })
            );
            // Append new options
            data.forEach((option) => {
              $dropdown.append(
                $("<option>", {
                  value: option.id,
                  text: option.name,
                })
              );
            });
          },
          error: (jqXHR, textStatus, errorThrown) => {
            console.error("Error fetching options:", textStatus, errorThrown);
          },
        });
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    },
    fetchState(id) {
      console.log("working...222");
      $.ajax({
        url: process.env.VUE_APP_API_URL +`/fetchState?id=${id}`,
        method: 'GET',
        success: (data) => {
          // Populate dropdown options
          const $dropdown = $('#placeManualDistrictProvince');
          $dropdown.empty(); // Clear existing options
          $dropdown.append($("<option>", {
            value: 0,
            text: "Select State or Province",
          }))
          // Append new options
          data.forEach(option => {
            $dropdown.append($('<option>', {
              value: option.id,
              text: option.name
            }));
          });
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.error('Error fetching options:', textStatus, errorThrown);
        }
      });
    },

    fetchCity(cId, sId) {
      console.log("working...222");
      $.ajax({
        url: process.env.VUE_APP_API_URL +`/fetchCity?cId=${cId}&&sId=${sId}`,
        method: 'GET',
        success: (data) => {
          // Populate dropdown options
          const $dropdown = $('#placeManualCity');
          $dropdown.empty(); // Clear existing options
          $dropdown.append($("<option>", {
            value: 0,
            text: "Select City",
          }))
          // Append new options
          data.forEach(option => {
            $dropdown.append($('<option>', {
              value: option.id,
              text: option.name
            }));
          });
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.error('Error fetching options:', textStatus, errorThrown);
        }
      });
    },

    initializeAutocomplete() {


    },
    getCountryCodesForAddressFiltter() {
      /* eslint-disable */
      var map, marker, geocoder;

      // AJAX GET request to fetch country codes from Laravel API
      $.ajax({
        url: process.env.VUE_APP_API_URL +'/getCountryCodes',
        type: 'GET',
        dataType: 'json',
        success: function (response) {
          // Convert response array to a comma-separated string for Google Maps componentRestrictions
          var countryCodes = response.join(',');
          var allowedCountries = response;


          // Initialize Google Maps Autocomplete
          var input = document.getElementById('placeAutoAddress');

          var autocomplete = new google.maps.places.Autocomplete(input);
          var autocompleteService = new google.maps.places.AutocompleteService();
          console.log(countryCodes);
          console.log(response);
          // Restrict autocomplete to the fetched country codes
          autocomplete.setComponentRestrictions({ 'country': response });

          autocomplete.addListener('place_changed', function () {
            var place = autocomplete.getPlace();

            if (!place.geometry) {
              alert("No address found. Please try another search.");
              return;
            }

            var country = '';
            var isCountryValid = false;

            if (place.address_components) {
              place.address_components.forEach(function (component) {
                var componentType = component.types[0];
                switch (componentType) {
                  case 'country':
                    country = component.short_name; // Use short_name for country code
                    if (response.includes(country)) {
                      isCountryValid = true;
                    }
                    break;
                  case 'administrative_area_level_1':
                    $('#placeAutoState').val(component.long_name);
                    break;
                  case 'locality':
                    $('#placeAutoCity').val(component.long_name);
                    break;
                  default:
                    break;
                }
              });

              if (isCountryValid) {
                $('#placeAutoCountry').val(place.address_components.find(c => c.types.includes('country')).long_name);
                $('#placeAutoLattitude').val(place.geometry.location.lat());
                $('#placeAutoLongtitude').val(place.geometry.location.lng());
              } else {
                Swal.fire({
                  title: 'Error!',
                  text: 'Selected address is not in an allowed country.',
                  icon: 'error',
                  confirmButtonText: 'OK'
                }).then((result) => {
                  if (result.isConfirmed) {
                    if (marker) {
                      // Center the map and add a new marker
                      map.setCenter({ lat: 7.8731, lng: 80.7718 });
                      map.setZoom(7.5); // Adjust the zoom level as needed
                    }
                  }
                });
                $('#placeAutoAddress').val('');
                $('#placeAutoCountry').val('');
                $('#placeAutoState').val('');
                $('#placeAutoCity').val('');
                $('#placeAutoLattitude').val('');
                $('#placeAutoLongtitude').val('');
              }

              if (marker) {
                marker.setMap(null); // Remove the previous marker
              }

              // Center the map and add a new marker
              map.setCenter({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() });
              map.setZoom(15); // Adjust the zoom level as needed

              marker = new google.maps.Marker({
                position: { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() },
                map: map,
                title: 'Selected Address'
              });

            }

          });

          // Initialize the map with default center
          geocoder = new google.maps.Geocoder(); // Initialize Geocoder
          map = new google.maps.Map(document.getElementById('map'), {
            center: { lat: 7.8731, lng: 80.7718 }, // Initial center coordinates (Srilanka)
            zoom: 7.5, // Initial zoom level
          });

          // Add a click event listener to the map
          map.addListener('click', function (event) {
            var lat = event.latLng.lat();
            var lng = event.latLng.lng();

            // Remove previous marker, if exists, and place a new one
            if (marker) {
              marker.setMap(null); // Remove the previous marker
            }

            // Place a new marker at the clicked location
            marker = new google.maps.Marker({
              position: { lat: lat, lng: lng },
              map: map,
              title: 'Selected Location'
            });

            var latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

            geocoder.geocode({ location: latlng }, function (results, status) {
              if (status === 'OK') {
                if (results[0]) {
                  var country = '';
                  var province = '';
                  var city = '';

                  // Loop through address components to find country, province, and city
                  results[0].address_components.forEach(function (component) {
                    var componentType = component.types[0];
                    switch (componentType) {
                      case 'country':
                        country = component.long_name; // Full country name
                        break;
                      case 'administrative_area_level_1': // Province or state
                        province = component.long_name;
                        break;
                      case 'locality': // City
                        city = component.long_name;
                        break;
                      default:
                        break;
                    }
                  });

                  if (allowedCountries.includes(results[0].address_components.find(c => c.types.includes('country')).short_name)) {
                    // Place marker
                    if (marker) {
                      marker.setMap(null); // Remove the previous marker
                    }

                    marker = new google.maps.Marker({
                      position: latlng,
                      map: map,
                      title: 'Selected Location'
                    });

                    // Populate the input fields
                    $('#placeAutoAddress').val(results[0].formatted_address);
                    $('#placeAutoLattitude').val(lat);
                    $('#placeAutoLongtitude').val(lng);
                    $('#placeAutoCountry').val(country);
                    $('#placeAutoState').val(province);
                    $('#placeAutoCity').val(city);


                  } else {
                    Swal.fire({
                      title: 'Error!',
                      text: 'Selected address is not in an allowed country.',
                      icon: 'error',
                      confirmButtonText: 'OK'
                    }).then((result) => {
                      if (result.isConfirmed) {
                        if (marker) {
                          marker.setMap(null); // Remove the previous marker
                        }
                      }
                    });
                  }
                } else {
                  alert('No results found.');
                }
              } else {
                alert('Geocoder failed due to: ' + status);
              }
            });
          });


          // Debounce function to delay the checking
          function debounce(func, wait) {
            let timeout;
            return function (...args) {
              clearTimeout(timeout);
              timeout = setTimeout(() => func.apply(this, args), wait);
            };
          }

          // Function to check suggestions while typing
          function checkSuggestions() {
            var query = input.value;
            if (query.length < 3) return; // Only check if query length is sufficient

            autocompleteService.getPlacePredictions({ input: query, componentRestrictions: { country: 'LK' } }, function (predictions, status) {
              if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
                Swal.fire({
                  title: 'Error!',
                  text: 'Your attraction address is new for our database. Please enter manually or recheck your address.',
                  icon: 'error',
                  confirmButtonText: 'OK'
                }).then((result) => {
                  if (result.isConfirmed) {
                    $('#manualAddress').show();
                  }
                });
              }
            });
          }

          // Attach debounce to input event
          $(input).on('input', debounce(checkSuggestions, 500)); // Adjust debounce delay as needed
        },
        error: function (xhr, status, error) {
          console.error("Error fetching country codes:", error);
          alert("Unable to fetch country codes. Please try again later.");
        }
      });

    },

    saveFormData(base64Images) {
      // Collect the data from the form fields
      var name = $('#name').val();
      var mainCategory = $('#mainCategory').val();
      var subCategory = $('#subCategory').val();
      var addressType = $('#addressType').val();
      var description = $('#comments').html().trim(); // Assuming you want to get the HTML content of QuillEditor
      var placeAutoAddress = $('#placeAutoAddress').val();
      var placeAutoLattitude = $('#placeAutoLattitude').val();
      var placeAutoLongtitude = $('#placeAutoLongtitude').val();
      var placeAutoCountry = $('#placeAutoCountry').val();
      var placeAutoState = $('#placeAutoState').val();
      var placeAutoCity = $('#placeAutoCity').val();
      var placeManualAddress = $('#placeManualAddress').val();
      var placeManualCountry = $('#placeManualCountry').val();
      var placeManualDistrictProvince = $('#placeManualDistrictProvince').val();
      var placeManualCity = $('#placeManualCity').val();



      // Validation
      var isValid = true;
      var errorMessage = '';
      $('.error-message').remove();

      if (!name) {
        isValid = false;
        $('#name').after('<span class="error-message" style="color: red;">Place name is required.</span>');
      }

      if (!mainCategory) {
        isValid = false;
        $('#mainCategory').after('<span class="error-message" style="color: red;">Category is required.</span>');
      }

      if (!subCategory) {
        isValid = false;
        $('#subCategory').after('<span class="error-message" style="color: red;">Sub Category is required.</span>');
      }

      if (!description) {
        isValid = false;
        $('#comments').after('<span class="error-message" style="color: red;">Description is required.</span>');
      }
      if (base64Images == '') {
        isValid = false;
        $('#imageUpload1').after('<span class="error-message" style="color: red;">Minimum one image is required.</span>');
        base64Images = '';
      }


      // Check if auto address fields are filled
      if (addressType == 0) {

        if (!placeAutoAddress) {
          isValid = false;
          $('#placeAutoAddress').after('<span class="error-message" style="color: red;">Address is required.</span>');
        }
        if (!placeAutoLattitude) {
          isValid = false;
          $('#placeAutoLattitude').after('<span class="error-message" style="color: red;">Latitude is required.</span>');
        }
        if (!placeAutoLongtitude) {
          isValid = false;
          $('#placeAutoLongtitude').after('<span class="error-message" style="color: red;">Longitude is required.</span>');
        }
        if (!placeAutoCountry) {
          isValid = false;
          $('#placeAutoCountry').after('<span class="error-message" style="color: red;">Country is required.</span>');
        }
        if (!placeAutoState) {
          isValid = false;
          $('#placeAutoState').after('<span class="error-message" style="color: red;">State is required.</span>');
        }
        if (!placeAutoCity) {
          isValid = false;
          $('#placeAutoCity').after('<span class="error-message" style="color: red;">City is required.</span>');
        }
      }
      else {

        if (!placeManualAddress) {
          isValid = false;
          $('#placeManualAddress').after('<span class="error-message" style="color: red;">Address is required.</span>');
        }
        if (!placeManualCountry) {
          isValid = false;
          $('#placeManualCountry').after('<span class="error-message" style="color: red;">Country is required.</span>');
        }
        if (!placeManualDistrictProvince) {
          isValid = false;
          $('#placeManualDistrictProvince').after('<span class="error-message" style="color: red;">District/province is required.</span>');
        }
        if (!placeManualCity) {
          isValid = false;
          $('#placeManualCity').after('<span class="error-message" style="color: red;">City is required.</span>');
        }
      }


      // Show error messages if validation fails
      if (!isValid) {
        console.log(errorMessage);
        return;
      }

      // Collect functional days data
      var functionalDays = {
        mondayOpen: $('#mondayOpen').val(),
        mondayClose: $('#mondayClose').val(),
        tuesdayOpen: $('#tuesdayOpen').val(),
        tuesdayClose: $('#tuesdayClose').val(),
        wednesdayOpen: $('#wednesdayOpen').val(),
        wednesdayClose: $('#wednesdayClose').val(),
        thursdayOpen: $('#ThursdayOpen').val(),
        thursdayClose: $('#ThursdayClose').val(),
        fridayOpen: $('#FridayOpen').val(),
        fridayClose: $('#FridayClose').val(),
        saturdayOpen: $('#SaturdayOpen').val(),
        saturdayClose: $('#SaturdayClose').val(),
        sundayOpen: $('#SundayOpen').val(),
        sundayClose: $('#SundayClose').val()
      };
      $.ajax({
        url: process.env.VUE_APP_API_URL +'/saveApiPlace',
        method: 'POST',
        data: {
          name: name,
          mainCategory: mainCategory,
          subCategory: subCategory,
          description: description,
          placeAutoAddress: placeAutoAddress,
          placeAutoLattitude: placeAutoLattitude,
          placeAutoLongtitude: placeAutoLongtitude,
          placeAutoCountry: placeAutoCountry,
          placeAutoState: placeAutoState,
          placeAutoCity: placeAutoCity,
          placeManualAddress: placeManualAddress,
          placeManualCountry: placeManualCountry,
          placeManualDistrictProvince: placeManualDistrictProvince,
          placeManualCity: placeManualCity,
          functionalDays: functionalDays,
          addressType: addressType,
          placeImages: base64Images

        },
        success: function (response) {
          // Handle success response
          console.log(response);
          Swal.fire({
            title: 'Success!',
            text: 'Thanks for the attraction place information!',
            icon: 'success',
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              location.reload(); // Refresh the page
            }
          });
        },
        error: function (error) {
          // Handle error response
          console.log(error);
          Swal.fire({
            title: 'Error!',
            text: error,
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
      });
    },

    initializeEventListeners() {


      $('#fillMore').hide();

      $('#fillUp').click(function () {
        $('#fillMore').show();
        $('#categoryPage').hide();
        $('#testiMoniPage').hide();
        $('#topThreePage').hide();
        $('#subUserPage').hide();
        $('#topSliderCon').hide();

        // Smooth scroll to the #fillMore element
        $('html, body').animate({
          scrollTop: $('#fillMore').offset().top
        }, 1000); // Adjust the duration (1000 milliseconds) as needed
      });

      let filesArray = []; // Array to keep track of selected files
      var base64Images = []; // Array to store base64 images

      $('#imageUpload1').on('change', function (event) {

        var files = event.target.files; // Get selected files
        var previewContainer = $('#imagePreview');

        previewContainer.empty(); // Clear previous previews
        filesArray = []; // Reset files array

        if (files.length === 0) {
          return;
        }

        // Loop through each file
        for (var i = 0; i < files.length; i++) {
          var file = files[i];
          var reader = new FileReader();

          reader.onload = (function (file) {
            return function (e) {
              // Create a container for the image and delete button
              var imgContainer = $('<div>', {
                style: 'position: relative; display: inline-block; margin: 5px;'
              });

              // Create and style the image element
              var img = $('<img>', {
                style: 'max-width: 100%; max-height: 150px; object-fit: cover;',
                src: e.target.result,
                alt: file.name
              });

              // Create and style the delete button
              var deleteBtn = $('<button>', {
                style: 'position: absolute; top: 5px; right: 5px; background: rgba(255, 0, 0, 0.7); color: white; border: none; border-radius: 3px; cursor: pointer;',
                text: 'X'
              });

              // Handle delete button click event
              deleteBtn.on('click', function () {
                imgContainer.remove(); // Remove image container from the DOM
                filesArray = filesArray.filter(f => f !== file); // Remove file from the array
              });

              // Append image and delete button to the container
              imgContainer.append(img).append(deleteBtn);
              // Append the container to the preview container
              previewContainer.append(imgContainer);

              base64Images.push({
                name: file.name,
                data: e.target.result
              });

            };
          })(file);

          // Read file as data URL
          reader.readAsDataURL(file);
          // Add file to the array
          filesArray.push(file);
        }
      });



      $('#autoAddress').hide();
      $('#subCatDiv').hide();

      const mainCategory = document.getElementById('mainCategory');
      mainCategory.addEventListener('change', (event) => {
        const selectedValue = event.target.value;
        if (selectedValue == '') {
          $('#subCatDiv').hide();
        }
        else {
          $('#subCatDiv').show();
        }
        this.fetchSubcategories(selectedValue);
      });

      const autoAddress = document.getElementById('autoAddress');
      autoAddress.addEventListener('click', () => {
        this.autoLocation();
      });

      const manualAddress = document.getElementById('manualAddress');
      manualAddress.addEventListener('click', () => {
        this.manualLocation();
      });

      const country = document.getElementById('placeManualCountry');
      country.addEventListener('change', (event) => {
        const selectedValue = event.target.value;
        this.fetchState(selectedValue);
      });

      const state = document.getElementById('placeManualDistrictProvince');
      state.addEventListener('change', (event) => {
        const selectedValue = event.target.value;
        const country = $('#placeManualCountry').val();

        console.log(country, selectedValue);
        this.fetchCity(country, selectedValue);
      });

      const saveBtn = document.getElementById('saveBtn');
      saveBtn.addEventListener('click', () => {
        this.saveFormData(base64Images);
        console.log('Action confirmed');
      });

      //$('#timeTable').show();
      $('#24hr').hide();
      // $('#no').click(function () {
      //   $('#openType').val(2);
      //   $('#question').show();
      //   $('#timeTable').show();
      // });
      // $('#no2').click(function () {
      //   $('#openType').val(2);
      //   $('#24hr').hide();
      //   $('#question').show();
      //   $('#timeTable').show();
      // });
      $('#yes').change(function () {
        if ($('#yes').is(":checked")) {
          $('#timeTable').hide();
        } else {
          $('#timeTable').show();
        }
      });

    }
  }

};

</script>

<style scoped>
#map {
  height: 600px;
  /* Adjust the height as needed */
  width: 100%;
  /* Adjust the width as needed */
}

.inputText {
  border-radius: 10px;
  border: 0.5px solid rgba(0, 0, 0, 0.2);
}

.preview {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}
</style>